
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/comparables",
      function () {
        return require("private-next-pages/tools/comparables/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/comparables"])
      });
    }
  